// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "paper-b7sQs";
var _3 = "header-mjfSQ";
var _4 = "title-2Vdn1";
var _5 = "contentWrapper-1BNCH";
var _6 = "footer-2RdH6";
var _7 = "buttons-AUPa6";
var _8 = "closeButton-1AU5-";
var _9 = "cancelButton-1h2lx";
var _a = "confirmButton-3vTsy";
var _b = "dialogContent_root-3uUvF";
var _c = "checkData__title-1PC2q";
export { _1 as "__esModule", _2 as "paper", _3 as "header", _4 as "title", _5 as "contentWrapper", _6 as "footer", _7 as "buttons", _8 as "closeButton", _9 as "cancelButton", _a as "confirmButton", _b as "dialogContent_root", _c as "checkData__title" }
export default { "__esModule": _1, "paper": _2, "header": _3, "title": _4, "contentWrapper": _5, "footer": _6, "buttons": _7, "closeButton": _8, "cancelButton": _9, "confirmButton": _a, "dialogContent_root": _b, "checkData__title": _c }
